import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { updateInstituicao } from '../Usuario/api-usuario';
import { findByCurrentUser } from './api-usuario-instituicao';
import { toast } from 'react-toastify';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { useDispatch, useSelector } from 'react-redux';
import { setUsuario } from '../Usuario/actions/actions';
import { Grid } from '@mui/material';
import GridPaper from '../../util/GridPaper';



export default function UsuarioInstituicaoTable() {
    const usuario = useSelector(state => state.usuario);
    const dispatch = useDispatch();
    const [usuarioInstituicoes, setUsuarioInstituicoes] = useState([]);


    useEffect(() => {

        findByCurrentUser().then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                setUsuarioInstituicoes(data);
            }
        });

    }, []);


    const handleAtivar = (codInstituicao) => {
        updateInstituicao(codInstituicao).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                dispatch(setUsuario(data));
                toast.success("Instituição Ativo Alterado.", {
                    position: "bottom-left"
                });
                // window.location.reload(false);
            }
        });
    }

    return (
        <>
            {usuarioInstituicoes.length > 0 ?

                <Grid container direction='column' spacing={3}>
                    <Grid>
                        <Typography variant="h5">
                            Alterar Instituição Ativo
                        </Typography>
                    </Grid>
                    <GridPaper>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Instituição</TableCell>
                                    <TableCell>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {usuarioInstituicoes.map((ui) => (
                                    <TableRow key={ui.codigo}>
                                        <TableCell>{ui.instituicao.descricao}</TableCell>
                                        <TableCell>
                                            {usuario === null || usuario.instituicao.codigo !== ui.instituicao.codigo ?
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleAtivar(ui.instituicao.codigo)}
                                                >
                                                    Ativar
                                                </Button>
                                                : 'Selecionado'}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </GridPaper>
                </Grid >
                : ''
            }
        </>
    );
}